import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import "./StartPayrollPage.css";

const StartPayrollPage = () => {
    const { id: businessId } = useParams();
    const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} }); // For tax status
    const navigate = useNavigate();
    const [payPeriod, setPayPeriod] = useState(null); // Tracks pay period details
    const [hasPayrollData, setHasPayrollData] = useState(false); // Tracks payroll data existence
    const [loading, setLoading] = useState(true); // Tracks loading state
    const [noPreviousPayroll, setNoPreviousPayroll] = useState(false); // Checkbox state
    const [showFundingWarning, setShowFundingWarning] = useState(false);


// REPLACE this whole useEffect
useEffect(() => {
  const fetchData = async () => {
    try {
      // Fetch payroll data
      const payrollResponse = await api.get(`/business/${businessId}/payroll-data`);
      setHasPayrollData(payrollResponse.data.hasData);

      // Fetch pay period data
      const payPeriodResponse = await api.get(`/business/${businessId}/pay-period`);
      if (
        !payPeriodResponse.data.start_date &&
        !payPeriodResponse.data.end_date &&
        !payPeriodResponse.data.pay_date &&
        !payPeriodResponse.data.frequency
      ) {
        setPayPeriod(null);
      } else {
        setPayPeriod(payPeriodResponse.data);
      }

      // Fetch tax status
      const { data: taxStatusData } = await api.get(`/tax-status-fetch/${businessId}`);
      setTaxStatus(taxStatusData);

      const fundingResponse = await api.get(`/billing/funding-check/${businessId}`);
      setShowFundingWarning(fundingResponse.data.showFundingWarning);

    } catch (error) {
      if (error.response?.status === 404) {
        setPayPeriod(null);
      } else {
        console.error("Error fetching data:", error);
        alert("Failed to fetch data.");
      }
    } finally {
      setLoading(false);
    }
  };

  // NEW: check if this business already has *pay periods* and redirect if so
  // This prevents staying on /start-payroll after switching businesses.
  let cancelled = false;
  const redirectIfHasPeriods = async () => {
    try {
      const { data } = await api.get(`/payroll/periods/${businessId}`);
      if (!cancelled && Array.isArray(data) && data.length > 0) {
        navigate(`/dashboard/business/${businessId}/viewpayroll`, { replace: true });
        return true;
      }
    } catch {
      // swallow errors; we'll just fall back to normal fetch
    }
    return false;
  };

  (async () => {
    const redirected = await redirectIfHasPeriods();
    if (!redirected) {
      await fetchData();
    } else {
      // Avoid a brief "Loading..." flash during replace navigation
      setLoading(false);
    }
  })();

  return () => { cancelled = true; };
}, [businessId, navigate]);



    // Navigate to Set Pay Period page
    const handleSetPayPeriod = () => {
        if (hasPayrollData || noPreviousPayroll) {
            navigate(`/dashboard/business/${businessId}/set-pay-period`);
        } else {
            alert("You must either add previous payroll data or confirm there are no records to enter.");
        }
    };

    // Delete pay period details
    const handleDeletePayPeriod = async () => {
        try {
            await api.delete(`/business/${businessId}/pay-period`);
            alert("Pay period deleted successfully.");
            setPayPeriod(null); // Clear pay period state
        } catch (error) {
            console.error("Error deleting pay period:", error);
            alert("Failed to delete pay period.");
        }
    };

    // Show loading state while fetching data
    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="start-payroll-container">
            <h2 className="page-title-start">Start Payroll</h2>
          
            

            <div className="step-container">
                {/* Step 1: Add/Edit Previous Payrolls */}
                <div
  className={`step ${hasPayrollData ? "has-payroll" : "no-payroll"}`}
>
        <div className="step-header">
        <div className="step-number">Step 1</div>
            <h3>{hasPayrollData ? "Edit Previous Payroll" : "Add Previous Payroll"}</h3>
        </div>
            <p className={`steponecontent ${hasPayrollData ? "has-payroll-content" : "no-payroll-content"}`}>
            {hasPayrollData
            ? "Edit existing payroll records to ensure accuracy."
            : "Add payrolls from the start of the year to maintain accurate and complete payroll data for the current year."}
            </p>
            {!hasPayrollData && (
                <label className="checkbox-container">
                <input
                type="checkbox" id="checkbox"
                checked={noPreviousPayroll}
                onChange={(e) => setNoPreviousPayroll(e.target.checked)}
                />
                There are no previous payroll records to enter
            </label>
        )}
         
         <div className="button-container">
    
            <button
            className="previous-button"
            onClick={() =>
            navigate(
            `/dashboard/business/${businessId}/${hasPayrollData ? "edit-previous-payroll" : "past-payroll"}`
            )
        }
        >
        {hasPayrollData ? "Edit Previous Payroll" : "Add Previous Payroll"}
        </button>
        </div>
    </div>


                {/* Step 2: Pay Period Section */}
                {payPeriod ? (
    <div className="step step-2" >
        
  
    <div className="step-header">
      <div className="step-number">Step 2</div>
      <h3>Pay Period Details {payPeriod.name}</h3>
    </div>

    <div className="payschedulecontent">
    {/* Start Date */}
    <div className="pay-period-item">
      <span className="pay-period-label">Start Date</span>
      <span className="pay-period-value">
        <div className="calender">
        <div className="left">  
          <p id="date">{new Date(payPeriod.start_date).getDate()}</p>
          <p id="day">{new Date(payPeriod.start_date).toLocaleString('default', { weekday: 'long' })}</p>
        </div>
        <div className="right">
          <p id="month">{new Date(payPeriod.start_date).toLocaleString('default', { month: 'short' })}</p>
          <p id="year">{new Date(payPeriod.start_date).getFullYear()}</p>
        </div>  
        </div>
      </span>
    </div>

    {/* End Date */}
    <div className="pay-period-item">
      <span className="pay-period-label">End Date</span>
      <span className="pay-period-value">
      <div className="calender">
        <div className="left">  
          <p id="date">{new Date(payPeriod.end_date).getDate()}</p>
          <p id="day">{new Date(payPeriod.end_date).toLocaleString('default', { weekday: 'long' })}</p>
        </div>
        <div className="right">
          <p id="month">{new Date(payPeriod.end_date).toLocaleString('default', { month: 'short' })}</p>
          <p id="year">{new Date(payPeriod.end_date).getFullYear()}</p>
        </div>  
        </div>
      </span>
    </div>

    {/* Pay Date */}
    <div className="pay-period-item">
      <span className="pay-period-label">Pay Date</span>
      <span className="pay-period-value">
      <div className="calender">
        <div className="left">  
          <p id="date">{new Date(payPeriod.pay_date).getDate()}</p>
          <p id="day">{new Date(payPeriod.pay_date).toLocaleString('default', { weekday: 'long' })}</p>
        </div>
        <div className="rightgreen">
          <p id="month">{new Date(payPeriod.pay_date).toLocaleString('default', { month: 'short' })}</p>
          <p id="year">{new Date(payPeriod.pay_date).getFullYear()}</p>
        </div>  
        </div>
      </span>
    </div>
    </div>

    {/* Frequency */}
    <div className="frequency-item">
      <span className="pay-period-label">FREQUENCY TYPE:- </span>
      <span className="pay-period-label">{payPeriod.frequency.toUpperCase()}</span>
    </div>
       <div className="button-container">
        <button className="delete-button" onClick={handleDeletePayPeriod}>
            Delete Pay Period
        </button>
        </div>
    </div>
) : (
    <div className="no-pay-period">
        <div className="step-header">
        <div className="step-number">Step 2</div>
        <h3>No Pay Period Set</h3>
        <button className="pay-button" onClick={handleSetPayPeriod}>
            Set Pay Period
        </button>
    </div>
    </div>
)}


        

                {/* Step 3: Start New Payroll */}
                <div className="step">
    <div className="step-header">
        <div className="step-number">Step 3</div>
        <h3>Start New Payroll</h3>
    </div>
    {/* Display tax status */}
    
            {taxStatus.noIssues ? (
                <p style={{textAlign:'center', color:'green'}}>All tax information is up to date!</p>
                
            ) : (
                <>
                <p style={{textAlign:'center', color:'red', margin:'20px'}}>There are missing tax fields. Please fill tax information.</p>
                <div className="button-container">
                <button className="tax-button-start" onClick={() => navigate(`/dashboard/business/${businessId}/detect`)}>
            Tax Information
        </button>
        </div>
        </>
            )}

            {!showFundingWarning ? (
  <div className="button-container">
  <button
    className="step-button"
    onClick={async () => {
      try {
        // Validate previous payroll data
        const payrollResponse = await api.get(`/business/${businessId}/payroll-data`);
        const hasPayrollData = payrollResponse.data.hasData;

        // Validate pay period data
        const payPeriodResponse = await api.get(`/business/${businessId}/pay-period`);
        const payPeriod = payPeriodResponse.data;

        if (!hasPayrollData && !noPreviousPayroll) {
          alert("You must add or confirm previous payroll records before starting a new payroll.");
          return;
        }

        if (!payPeriod.start_date || !payPeriod.end_date || !payPeriod.pay_date || !payPeriod.frequency) {
          alert("You must set a valid pay period before starting a new payroll.");
          return;
        }

        navigate(`/dashboard/business/${businessId}/process-payroll`);
      } catch (error) {
        console.error("Error validating data for starting payroll:", error);
        alert("Failed to validate data. Please try again.");
      }
    }}
  >
    Start New Payroll
  </button>
  </div>
) : (
  <p style={{ textAlign: 'center', color: 'red', marginTop: '10px' }}>
    No funding account is set up. Please add a funding account before starting payroll.
  </p>
)}

    
    
</div>

            </div>
        </div>
    );
};

export default StartPayrollPage;

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import "./StartPayrollPage.css";

// const StartPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const navigate = useNavigate();
//     const [payPeriod, setPayPeriod] = useState(null); // Store pay period details
//     const [hasPayrollData, setHasPayrollData] = useState(null); // Track whether payroll data exists
//     const [noPreviousPayroll, setNoPreviousPayroll] = useState(false); // Checkbox state

//     useEffect(() => {
//         const fetchPayPeriod = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/pay-period`);
//                 setPayPeriod(data); // Set pay period details if available
//             } catch (error) {
//                 if (error.response && error.response.status === 404) {
//                     setPayPeriod(null); // No pay period found
//                 } else {
//                     console.error("Error fetching pay period:", error);
//                     alert("Failed to fetch pay period.");
//                 }
//             }
//         };

//         const checkPayrollData = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/payroll-data`);
//                 setHasPayrollData(data.hasData); // Assume the API returns { hasData: true/false }
//             } catch (error) {
//                 console.error("Error checking payroll data:", error);
//                 alert("Failed to check payroll data.");
//             }
//         };

//         fetchPayPeriod();
//         checkPayrollData();
//     }, [businessId]);

//     const handleDelete = async () => {
//         try {
//             await api.delete(`/business/${businessId}/pay-period`, {
//                 headers: {
//                     Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//                 },
//             });
//             alert("Pay period deleted successfully.");
//             setPayPeriod(null); // Reset pay period state
//         } catch (error) {
//             console.error("Error deleting pay period:", error);
//             alert("Failed to delete pay period.");
//         }
//     };

//     const handleSetPayPeriod = () => {
//         if (hasPayrollData || noPreviousPayroll) {
//             navigate(`/dashboard/business/${businessId}/set-pay-period`);
//         } else {
//             alert("You must either add previous payroll data or confirm there are no records to enter.");
//         }
//     };

//     if (payPeriod === null && hasPayrollData === null) {
//         return <p>Loading...</p>; // Show a loading state while the API is being called
//     }

//     return (
//         <div className="start-payroll-container">
//             <h2 className="page-title">Start Payroll</h2>
//             <div className="step-container">
//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">1</div>
//                         <h3>{hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}</h3>
//                     </div>
//                     <p>
//                         {hasPayrollData
//                             ? "Edit existing payroll records to ensure accuracy."
//                             : "Add payrolls from the start of the year to maintain accurate and complete payroll data for the current year."}
//                     </p>
//                     {!hasPayrollData && (
//                         <label className="checkbox-container">
//                             <input
//                                 type="checkbox"
//                                 checked={noPreviousPayroll}
//                                 onChange={(e) => setNoPreviousPayroll(e.target.checked)}
//                             />
//                             There are no previous payroll records to enter
//                         </label>
//                     )}
//                     <button
//                         className="step-button"
//                         onClick={() =>
//                             navigate(
//                                 `/dashboard/business/${businessId}/${hasPayrollData ? "edit-previous-payroll" : "add-previous-payroll"}`
//                             )
//                         }
//                     >
//                         {hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}
//                     </button>
//                 </div>

//                 {payPeriod ? (
//     <div className="pay-period-details">
//         <h3>Pay Period Details</h3>
//         <p><strong>Start Date:</strong> {payPeriod.start_date || "N/A"}</p>
//         <p><strong>End Date:</strong> {payPeriod.end_date || "N/A"}</p>
//         <p><strong>Pay Date:</strong> {payPeriod.pay_date || "N/A"}</p>
//         <p><strong>Frequency:</strong> {payPeriod.frequency || "N/A"}</p>
//         <button className="delete-button" onClick={handleDelete}>
//             Delete Pay Period
//         </button>
//     </div>
// ) : (
//     <div>
//         <h3>No Pay Period Set</h3>
//         <button className="step-button" onClick={handleSetPayPeriod}>
//             Set Pay Period
//         </button>
//     </div>
// )}



//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">3</div>
//                         <h3>Review Employees</h3>
//                     </div>
//                     <p>
//                         Ensure your employee records are up to date, including payment details, before proceeding with payroll processing.
//                     </p>
//                     <button className="step-button" onClick={() => navigate(`/business/${businessId}/review-employees`)}>
//                         Review Employees
//                     </button>
//                 </div>

//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">4</div>
//                         <h3>Start New Payroll</h3>
//                     </div>
//                     <p>
//                         Begin a new payroll cycle and calculate payments for your employees based on the defined pay period and employee records.
//                     </p>
//                     <button className="step-button" onClick={() => navigate(`/business/${businessId}/process-payroll`)}>
//                         Start New Payroll
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StartPayrollPage;





// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import "./StartPayrollPage.css"; // Import CSS for styling

// const StartPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const navigate = useNavigate();
//     const [hasPayrollData, setHasPayrollData] = useState(null); // Track whether payroll data exists
//     const [noPreviousPayroll, setNoPreviousPayroll] = useState(false); // Checkbox state

//     useEffect(() => {
//         const checkPayrollData = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/payroll-data`);
//                 setHasPayrollData(data.hasData); // Assume the API returns { hasData: true/false }
//             } catch (error) {
//                 console.error("Error checking payroll data:", error);
//                 alert("Failed to check payroll data.");
//             }
//         };

//         checkPayrollData();
//     }, [businessId]);

//     const handleSetPayPeriod = () => {
//         if (hasPayrollData || noPreviousPayroll) {
//             navigate(`/dashboard/business/${businessId}/set-pay-period`);
//         } else {
//             alert("You must either add previous payroll data or confirm there are no records to enter.");
//         }
//     };

//     if (hasPayrollData === null) {
//         return <p>Loading...</p>; // Show a loading state while the API is being called
//     }

//     return (
//         <div className="start-payroll-container">
//             <h2 className="page-title">Start Payroll</h2>
//             <div className="step-container">
//                 {/* Step 1: Add/Edit Previous Payrolls */}
//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">1</div>
//                         <h3>{hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}</h3>
//                     </div>
//                     <p>
//                         {hasPayrollData
//                             ? "Edit existing payroll records to ensure accuracy."
//                             : "Add payrolls from the start of the year to maintain accurate and complete payroll data for the current year."}
//                     </p>
//                     {!hasPayrollData && (
//                         <label className="checkbox-container">
//                             <input
//                                 type="checkbox"
//                                 checked={noPreviousPayroll}
//                                 onChange={(e) => setNoPreviousPayroll(e.target.checked)}
//                             />
//                             There are no previous payroll records to enter
//                         </label>
//                     )}
//                     <button
//                         className="step-button"
//                         onClick={() =>
//                             navigate(
//                                 `/dashboard/business/${businessId}/${hasPayrollData ? "edit-previous-payroll" : "add-previous-payroll"}`
//                             )
//                         }
//                     >
//                         {hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}
//                     </button>
//                 </div>

//                 {/* Step 2: Set Pay Period */}
//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">2</div>
//                         <h3>Set Pay Period</h3>
//                     </div>
//                     <p>
//                         Define the pay period for your employees, such as weekly, bi-weekly, or monthly. This is the first step in starting a new payroll cycle.
//                     </p>
//                     <button className="step-button" onClick={handleSetPayPeriod}>
//                         Set Pay Period
//                     </button>
//                 </div>

//                 {/* Step 3: Review Employees */}
//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">3</div>
//                         <h3>Review Employees</h3>
//                     </div>
//                     <p>
//                         Ensure your employee records are up to date, including payment details, before proceeding with payroll processing.
//                     </p>
//                     <button
//                         className="step-button"
//                         onClick={() => navigate(`/business/${businessId}/review-employees`)}
//                     >
//                         Review Employees
//                     </button>
//                 </div>

//                 {/* Step 4: Start New Payroll */}
//                 <div className="step">
//                     <div className="step-header">
//                         <div className="step-number">4</div>
//                         <h3>Start New Payroll</h3>
//                     </div>
//                     <p>
//                         Begin a new payroll cycle and calculate payments for your employees based on the defined pay period and employee records.
//                     </p>
//                     <button
//                         className="step-button"
//                         onClick={() => navigate(`/business/${businessId}/process-payroll`)}
//                     >
//                         Start New Payroll
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StartPayrollPage;



// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";

// const StartPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const navigate = useNavigate();
//     const [hasPayrollData, setHasPayrollData] = useState(null); // Track whether payroll data exists
//     const [noPreviousPayroll, setNoPreviousPayroll] = useState(false); // Checkbox state

//     useEffect(() => {
//         const checkPayrollData = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/payroll-data`);
//                 setHasPayrollData(data.hasData); // Assume the API returns { hasData: true/false }
//             } catch (error) {
//                 console.error("Error checking payroll data:", error);
//                 alert("Failed to check payroll data.");
//             }
//         };

//         checkPayrollData();
//     }, [businessId]);

//     const handleSetPayPeriod = () => {
//         if (hasPayrollData || noPreviousPayroll) {
//             // Navigate to Set Pay Period if edit is visible or checkbox is checked
//             navigate(`/dashboard/business/${businessId}/set-pay-period`);
//         } else {
//             alert("You must either add previous payroll data or confirm there are no records to enter.");
//         }
//     };

//     if (hasPayrollData === null) {
//         return <p>Loading...</p>; // Show a loading state while the API is being called
//     }

//     return (
//         <div>
//             <h2>Start Payroll</h2>
//             <div>
//                 {/* Option 1: Add/Edit Previous Payrolls */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>{hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}</h3>
//                     <p>
//                         {hasPayrollData
//                             ? "Edit existing payroll records to ensure accuracy."
//                             : "Add payrolls from the start of the year to maintain accurate and complete payroll data for the current year."}
//                     </p>
//                     {!hasPayrollData && (
//                         <div style={{ marginBottom: "10px" }}>
//                             <label>
//                                 <input
//                                     type="checkbox"
//                                     checked={noPreviousPayroll}
//                                     onChange={(e) => setNoPreviousPayroll(e.target.checked)}
//                                 />
//                                 There are no previous payroll records to enter
//                             </label>
//                         </div>
//                     )}
//                     <button
//                         onClick={() =>
//                             navigate(
//                                 `/dashboard/business/${businessId}/${hasPayrollData ? "edit-previous-payroll" : "add-previous-payroll"}`
//                             )
//                         }
//                     >
//                         {hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}
//                     </button>
//                 </div>

//                 {/* Option 2: Set Pay Period */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Set Pay Period</h3>
//                     <p>
//                         Define the pay period for your employees, such as weekly, bi-weekly, or monthly. This is the first step in starting a new payroll cycle.
//                     </p>
//                     <button onClick={handleSetPayPeriod}>Set Pay Period</button>
//                 </div>

//                 {/* Option 3: Review Employees */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Review Employees</h3>
//                     <p>
//                         Ensure your employee records are up to date, including payment details, before proceeding with payroll processing.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/review-employees`)}>
//                         Review Employees
//                     </button>
//                 </div>

//                 {/* Option 4: Start New Payroll */}
//                 <div>
//                     <h3>Start New Payroll</h3>
//                     <p>
//                         Begin a new payroll cycle and calculate payments for your employees based on the defined pay period and employee records.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/process-payroll`)}>
//                         Start New Payroll
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StartPayrollPage;




//WORKS GREAT//
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";

// const StartPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const navigate = useNavigate();
//     const [hasPayrollData, setHasPayrollData] = useState(null); // Track whether payroll data exists

//     useEffect(() => {
//         const checkPayrollData = async () => {
//             try {
//                 const { data } = await api.get(`/business/${businessId}/payroll-data`);
//                 setHasPayrollData(data.hasData); // Assume the API returns { hasData: true/false }
//             } catch (error) {
//                 console.error("Error checking payroll data:", error);
//                 alert("Failed to check payroll data.");
//             }
//         };

//         checkPayrollData();
//     }, [businessId]);

//     if (hasPayrollData === null) {
//         return <p>Loading...</p>; // Show a loading state while the API is being called
//     }

//     return (
//         <div>
//             <h2>Start Payroll</h2>
//             <div>
//                 {/* Option 1: Add/Edit Previous Payrolls */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>{hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}</h3>
//                     <p>
//                         {hasPayrollData
//                             ? "Edit existing payroll records to ensure accuracy."
//                             : "Add payrolls from the start of the year to maintain accurate and complete payroll data for the current year."}
//                     </p>
//                     <button
//                         onClick={() =>
//                             navigate(
//                                 `/dashboard/business/${businessId}/${hasPayrollData ? "edit-previous-payroll" : "add-previous-payroll"}`
//                             )
//                         }
//                     >
//                         {hasPayrollData ? "Edit Previous Payrolls" : "Add Previous Payrolls"}
//                     </button>
//                 </div>

//                 {/* Option 2: Set Pay Period */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Set Pay Period</h3>
//                     <p>
//                         Define the pay period for your employees, such as weekly, bi-weekly, or monthly. This is the first step in starting a new payroll cycle.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/set-pay-period`)}>
//                         Set Pay Period
//                     </button>
//                 </div>

//                 {/* Option 3: Review Employees */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Review Employees</h3>
//                     <p>
//                         Ensure your employee records are up to date, including payment details, before proceeding with payroll processing.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/review-employees`)}>
//                         Review Employees
//                     </button>
//                 </div>

//                 {/* Option 4: Start New Payroll */}
//                 <div>
//                     <h3>Start New Payroll</h3>
//                     <p>
//                         Begin a new payroll cycle and calculate payments for your employees based on the defined pay period and employee records.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/process-payroll`)}>
//                         Start New Payroll
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StartPayrollPage;




// import React from "react";
// import { useNavigate, useParams } from "react-router-dom";

// const StartPayrollPage = () => {
//     const { id: businessId } = useParams();
//     const navigate = useNavigate();

//     return (
//         <div>
//             <h2>Start Payroll</h2>
//             <div>
//                 {/* Option 1: Add Previous Payrolls */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Add Previous Payrolls</h3>
//                     <p>
//                         Add payrolls from the start of the year if you have any records. This helps maintain accurate and complete payroll data for the current year.
//                     </p>
//                     <button onClick={() => navigate(`/dashboard/business/${businessId}/add-previous-payroll`)}>
//                         Add Previous Payrolls
//                     </button>
//                     <button onClick={() => navigate(`/dashboard/business/${businessId}/edit-previous-payroll`)}>
//                         Edit Previous Payroll
//                     </button>
//                 </div>

//                 {/* Option 2: Set Pay Period */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Set Pay Period</h3>
//                     <p>
//                         Define the pay period for your employees, such as weekly, bi-weekly, or monthly. This is the first step in starting a new payroll cycle.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/set-pay-period`)}>
//                         Set Pay Period
//                     </button>
//                 </div>

//                 {/* Option 3: Review Employees */}
//                 <div style={{ marginBottom: "20px" }}>
//                     <h3>Review Employees</h3>
//                     <p>
//                         Ensure your employee records are up to date, including payment details, before proceeding with payroll processing.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/review-employees`)}>
//                         Review Employees
//                     </button>
//                 </div>

//                 {/* Option 4: Start New Payroll */}
//                 <div>
//                     <h3>Start New Payroll</h3>
//                     <p>
//                         Begin a new payroll cycle and calculate payments for your employees based on the defined pay period and employee records.
//                     </p>
//                     <button onClick={() => navigate(`/business/${businessId}/process-payroll`)}>
//                         Start New Payroll
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StartPayrollPage;
